/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
export default {
  components: {
    VPagination,

  },
  props: {
    envelopeId: {
      type: String,
      default: ""
    },
    recipientEmail: {
      type: String,
      default: ""
    },
    signorder:{
      type: String,
      default: ""
    }
   
  },
  data() {
    return {
     
      baseurl: process.env.VUE_APP_Service_URL,
      iframeurl:"",
      signingUrl:false,
      redirectpath:"",
      selectedenvelopid:"",
      selectedrecepientemal:"",
      testiframe:false,
      isSigningUrlFetching: false, // fetching the signing URL via API
      isIframeLoading: false,      // the iframe content is loading
    };
  },
  unmounted() {
    delete window.showAlert;
  },
  async mounted() {
    window.showAlert = this.showAlert.bind(this);
    window.addEventListener("studyIdChanged", (event) => {
      this.getiframeapi(this.envelopeId, this.recipientEmail)
    }
    );
    this.getiframeapi(this.envelopeId, this.recipientEmail)
    this.redirectpath = store.getters.getSigningFrom;
  },
  methods: {
    async testingiframe(){
this.testiframe = true;
    },

    async showAlert(message) {
       console.log(message);
     const idtoken = store.getters.getIdToken;
     console.log("idtocken", idtoken);
     
     await axios
        .post(`${this.baseurl}/etmf/docusign/activatenextsigner?envelopeId=${this.envelopeId}&signOrder=${this.signorder}&recipientEmail=${this.recipientEmail}`,
          {}, 
          {
            
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          this.Getsignerslist();
        })
        .catch((err) => {
          console.error(err)
        });
      // this.$router.go(-1);
      store.dispatch('setSigningFrom', null);
      this.$router.push(`/${this.redirectpath}`);
  },
  closesign(){
    store.dispatch('setSigningFrom', null);
    this.$router.push(`/${this.redirectpath}`);
//  this.$router.go(-1);
  },
async getiframeapi(envelopeId, recipientEmail) {
  this.selectedrecepientemal = recipientEmail;
  this.selectedenvelopid = envelopeId;

  const idtoken = store.getters.getIdToken;

  // Start the "preparing" loader
  this.isSigningUrlFetching = true;
  this.signingUrl = false;      // hide iframe area until we have a URL
  this.iframeurl = "";          // clear old URL if any

  try {
    const res = await axios.get(
      `${this.baseurl}/etmf/docusign/getsigningurl?envelopeId=${envelopeId}&recipientEmail=${recipientEmail}`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    // Show the iframe area
    this.signingUrl = true;

    // Now the iframe will begin loading → show iframe loader
    this.isIframeLoading = true;
    this.iframeurl = res.data.signingUrl; // setting src triggers the iframe load

  } catch (err) {
    console.log("No data found!", err);
    this.signingUrl = false; // keep the list view if it failed
  } finally {
    // Done fetching the URL itself
    this.isSigningUrlFetching = false;
  }
},

onIframeLoad() {
  // Iframe fully loaded → hide iframe loader
  this.isIframeLoading = false;
},



  },
};


